import createSvgIcon from "./utils/create_icon"

const ArticleOutline = createSvgIcon(<><g fill="currentColor"><path d="M8 7a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2zm-1 5a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1zm1 3a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2z" /><path clipRule="evenodd" d="M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm2 15V5h14v14z" fillRule="evenodd" /></g></>, "ArticleOutline")
export default ArticleOutline
